import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-content-container',
  templateUrl: 'content-container.component.html',
  styleUrls: ['content-container.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ContentContainerComponent {}
